import React, { useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    authorization, forwardingPath, getError, getLoggedIn,
    getLogin,
    getPassword, getRememberMe,
    rememberMeSwitch,
    setLogin,
    setPassword
} from "../../redux/reducers/login-reducer"
import {Redirect} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Typography } from '@material-ui/core';
import {  downloadActFile, downloadActFileHash, getInfoAct, getInfoViolation, getQrAct } from '../../redux/reducers/act-reducer';
import { useRedirect } from '../../hooks/useRedirect';
import { RouteNames } from '../../router/consts';


export const LoginForm = () => {
    const login = useSelector(getLogin)
    const password = useSelector(getPassword)
    const rememberMe = useSelector(getRememberMe)
    const isLoggedIn = useSelector(getLoggedIn)
    const error = useSelector(getError)
    const infoAct = useSelector(getInfoAct)
    const infoViolation = useSelector(getInfoViolation)

    const { redirect } = useRedirect()

    const dispatch = useDispatch()

   
    const onLoginChange = e => {
        dispatch(setLogin(e.target.value))
    }
    const onPasswordChange = e => {
        dispatch(setPassword(e.target.value))
    }
    const onRememberMeClick = () => {
        dispatch(rememberMeSwitch())
    }

    const submit = () => {
        dispatch(authorization(login, password))
    }

    useEffect(() => {
        if (infoAct !== null && infoViolation === null && isLoggedIn) return downloadActFile(infoAct.id)
    },[isLoggedIn])

    if (isLoggedIn) {redirect(RouteNames.HOME)}

    return (
    <>
        {infoAct !== null && infoViolation !== null ?
            <Typography
                variant='h6'
            >
                Подрядчик: {infoAct.content.podrCompanystep1}<br/> 
                Номер бригады: {infoAct.content.numBrigade}<br/>  
                Дата выявления: {infoAct.content.dateAkttime}<br/> 
                Статус нарушения: {infoViolation.removal_status === false ? 'Не устранено': 'Устранено'}<br/> 
                Для перехода к нарушению требуется авторизация
            </Typography>
            : infoAct !== null &&
            <Typography
                variant='h6'
            >
                Проект: {infoAct.name}<br/>
                Номер Акта: {infoAct.id}<br/>
                Для загрузки требуется авторизация

            </Typography>
        }
    
        <form>
            <TextField
                error={!!error}
                helperText={error?.login?.text}
                id={'outlined-basic'}
                label={'Логин'}
                fullWidth={true}
                margin={'normal'}
                autoComplete={'username'}
                variant={'outlined'}
                type={'email'}
                value={login}
                onChange={onLoginChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') submit()
                }}
            />
            <TextField
                error={!!error}
                helperText={error?.password?.text}
                id={'outlined-basic'}
                label={'Пароль'}
                fullWidth={true}
                margin={'normal'}
                variant={'outlined'}
                type={'password'}
                value={password}
                onChange={onPasswordChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') submit()
                }}
            />

            <FormControlLabel
                control={<Checkbox value={rememberMe}
                                onClick={onRememberMeClick} color="primary"/>}
                label="Запомнить меня"
            />
            <Grid container spacing={2} justifyContent="center">
                <Grid item>
                    <Button onClick={submit} variant="contained" color="primary" size={'large'}>
                        Вход
                    </Button>
                </Grid>
            </Grid>
        </form>
    </>);
};